var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoatBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boat-bottom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.4,
    height: 14.8,
    viewBox: "0 0 63.4 14.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.7,0c0,5.2,2,9,4.1,13.6a2.2,2.2,0,0,0,3.9,0C35.9,9,37.8,5.1,37.8,0H25.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatBottom);
export default __webpack_public_path__ + "static/media/boat-bottom.a1219f85f682e6f9dc27d90999f2ae36.svg";
export { ForwardRef as ReactComponent };